import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import { ContractStatusResponse, ErrorStore } from '@types'
import {
  STORE_CONTRACT_COLLECTING,
  STORE_CONTRACT,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'

export type ContractStatusState = ContractStatusResponse

type State = GenericState<ContractStatusState>

export const initialState: State = {
  data: {
    is_collecting: false,
    percentage: 0,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchStatus = createAsyncThunk<
  ContractStatusState,
  Promise<ContractStatusResponse>,
  Payload
>(
  STORE_CONTRACT_COLLECTING,
  async (promise: Promise<ContractStatusResponse>, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  ContractStatusState,
  ContractStatusResponse,
  Payload
>(fetchStatus, initialState.data)

const listSlice = createGenericSlice({
  name: STORE_CONTRACT,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = listSlice

const { clear } = actions

export { clear }

export default reducer
